
// src/Tiptap.tsx
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { Extension } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'
import { Node } from '@tiptap/core'
import Placeholder from '@tiptap/extension-placeholder'
import nodesApi from '@/api/nodes'
import React, { useEffect, useState, useRef } from 'react';
import useApi from '@/hooks/useApi';
import { useInputData } from '@/store/context/InputDataContext'
import Focus from '@tiptap/extension-focus'
import DropdownMenu from './DropdownMenu'
import { AgentsList } from '@/store/actions'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/store'

interface InputParam {
  name?: string;
}

interface DoubleBracketProps {
  content: string;
  onChange: (value: any) => void;
  inputParam?: { name?: string };
  isChecked?: true | false;
  className?: string | null;
  // isAgent: boolean;
   // Add this prop to receive parent ref
}

  // Custom extension to show menu on '{{'
  const CustomMenuExtension = (id: string, showDivById: (id: string) => void) => Extension.create({
      name: id,
    
      addProseMirrorPlugins() {
        console.log('CustomMenuExtension added',id) // Log to verify plugin addition
        let lastChars = ''; // Variable to keep track of the last few characters
        return [
          new Plugin({
            props: {
              handleTextInput(view, from, to, text) {
                lastChars += text; // Append the new text to lastChars
                if (lastChars.endsWith('{{')) {
                  showDivById(id); 
                  lastChars = ''; // Reset lastChars after detecting '{{'
                } else if (lastChars.length > 2) {
                  // Keep only the last two characters in lastChars
                  lastChars = lastChars.slice(-2);
                }
                console.log('Text input detected:', text, 'Last chars:', lastChars) // Added logging
                return false
              },
            },
          }),
        ]
      },
  })

  // Custom node for inserted text
  const InsertedText = Node.create({
    name: 'insertedText',
    group: 'inline',
    inline: true,
    atom: true,

    addAttributes() {
      return {
        text: {
          default: '',
        },
      }
    },

    parseHTML() {
      return [
        {
          tag: 'span[data-inserted-text]',
        },
      ]
    },

    renderHTML({ HTMLAttributes }) {
      return ['span', { ...HTMLAttributes, 'data-inserted-text': '' }, 0]
    },

    addNodeView() {
      return ({ node }) => {
        const dom = document.createElement('span')
        dom.style.color = 'white'
        dom.style.backgroundColor = '#27ae60'
        dom.style.padding = '2px'
        dom.style.fontSize = '12px'
        dom.style.borderRadius = '5px'
        dom.textContent = node.attrs.text
        return {
          dom,
        }
      }
    },
  })
  // define your extension array

  const DoubleBracket: React.FC<DoubleBracketProps> = ({ content, onChange, inputParam, className = null, isChecked=false}) => {

    const [visibleDivId, setVisibleDivId] = useState<string | null>(null); // State to track visible div id


    const dispatch = useDispatch<any>();
    const { loading, agents, error } = useSelector((state: RootState) => state.agents);

    useEffect(() => {
        dispatch(AgentsList());
    }, [dispatch]);

    // {item?.agentProfile?.title}
    

    // Function to show div by id
  const showDivById = (id: string) => {
    setVisibleDivId(id); // Set the id of the div to show
  };

  const extensions = [
    StarterKit,
    CustomMenuExtension(inputParam?.name || '', showDivById), 
    InsertedText,
    Placeholder.configure({
      placeholder: 'Start typing here...',
    }),
    Focus.configure({
      className: 'has-focus',
      mode: 'all',
    }), 
  ]

  const { inputData, setInputData } = useInputData();
  const menuRef = useRef<HTMLDivElement>(null); // Ref to track the custom menu
  const [editorId, setEditorId] = useState<string | null>(null);



  const editor = useEditor({
    extensions,
    content,
    editorProps: {
      attributes: {
        class: `border w-64 p-2 border-gray-200 focus:outline-none focus:border-blue-500 focus:border-2 rounded-md  ${className ? className : ""}`,
        name: inputParam?.name || ""
      },
    },
    onUpdate: ({ editor }) => {
        onChange(editor.getJSON());
    },
  });

  const insertText = (text: string, category: string) => {
      const { state, dispatch } = editor!.view;
      const { tr } = state;
      const position = state.selection.from - 2; // Position before the '{{'
      tr.insertText('', position, state.selection.from); // Remove the '{{'
      dispatch(tr);
      editor?.commands.insertContent({
        type: 'insertedText',
        attrs: { text: `{{${category+'.'+text}}}`},
      })
    // tr.insertText(text, position); // Insert the selected text
    setVisibleDivId('')
  }

  
  useEffect(()=>{
    if(isChecked === true){
      setVisibleDivId('') 
    }
},[isChecked])

  const getNodesApi = useApi(nodesApi.getAllNodes)

  useEffect(()=>{
    getNodesApi.request()
  }, [])

 
  const [ButtonData, setButtonData] = useState<{ [category: string]: { key: string; value: string }[] }>({});

  useEffect(() => {
    const transformedData = {} as { [category: string]: { key: string; value: string }[] };
  
    // Handling inputData transformation
    if (inputData && inputData.length > 0) {
      const inputCategory = 'User Input';
      transformedData[inputCategory] = inputData.map(item => ({
        key: item.inputText,
        value: item.testValue,
      }));
    }
  
    // Handling agents transformation
    if (agents && agents.length > 0) {
      const agentCategory = 'Agents';
      transformedData[agentCategory] = agents.map(agent => {
        const parsedData = JSON.parse(agent.raw_data);
        return {
          key: parsedData.agentProfile.title,
          value: parsedData.agentProfile.title,
        };
      });
    }
  
    // Update both pieces of state in one go
    setButtonData(transformedData);
  }, [inputData, agents]);
  



return (
  <>
    <EditorContent editor={editor} />
     <DropdownMenu
      inputParam={inputParam}
      ButtonData={ButtonData}
      visibleDivId={visibleDivId}
      menuRef={menuRef}
      insertText={insertText}
    />
  </>
);
};

export default DoubleBracket